import { Column, Entity, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { OutreachAudienceEntity } from './outreach-audience.entity';
import { OutreachCampaignEntity } from './outreach-campaign.entity';

@Entity('_outreach_campaign_audience')
export class OutreachCampaignAudienceEntity extends BaseEntity {
	@Column('enum', {
		name: '_status',
		enum: ['pending', 'processing', 'completed', 'failed'],
	})
	public status!: 'pending' | 'processing' | 'completed' | 'failed';

	@Column('int', { name: '_contact_count', default: () => "'0'" })
	public contactCount!: number;

	@Column('int', { name: '_processed_count', default: () => "'0'" })
	public processedCount!: number;

	@ManyToOne(
		() => OutreachCampaignEntity,
		(outreachCampaign) => outreachCampaign.outreachCampaignAudiences,
		{ onDelete: 'NO ACTION', onUpdate: 'NO ACTION' },
	)
	@JoinColumn([
		{ name: '_fk__outreach_campaign__id', referencedColumnName: 'id' },
	])
	public fkOutreachCampaign!: OutreachCampaignEntity;

	@ManyToOne(
		() => OutreachAudienceEntity,
		(outreachAudience) => outreachAudience.outreachCampaignAudiences,
		{ onDelete: 'NO ACTION', onUpdate: 'NO ACTION' },
	)
	@JoinColumn([
		{ name: '_fk__outreach_audience__id', referencedColumnName: 'id' },
	])
	public fkOutreachAudience!: OutreachAudienceEntity;
}
